import { statuses } from '@/returns/constants'

export const getLineItemsToReturn = (lineItems = []) => {
  return lineItems.map(item => ({
    label: item?.product?.name,
    amount: item?.price,
    variant: item?.variant?.options && Object.values(item?.variant?.options).join(' '),
  }))
}

export const getNewRequestedLineItems = (lineItems = [], newItems = []) => {
  const filteredLineItems = lineItems
    .filter(item => !item.cancelled_from_draft)
    .filter(item => item.exchanged_for_item)
    .map(item => ({
      label: item.exchanged_for_item?.product?.name,
      amount: item.exchanged_for_item?.price,
      variant:
        item?.exchanged_for_item?.variant?.options &&
        Object.values(item?.exchanged_for_item?.variant?.options).join(' '),
    }))

  const newRequestedItems = newItems
    .filter(item => !item.cancelled_from_draft)
    .map(item => ({
      label: item?.product?.name,
      amount: item?.price,
      variant: item?.variant?.options && Object.values(item?.variant?.options).join(' '),
    }))

  return [...filteredLineItems, ...newRequestedItems]
}

export const getRejectedLineItems = (lineItems = []) => {
  return lineItems
    .filter(item => item.status === statuses.rejected)
    .map(item => ({
      label: item?.product?.name,
      amount: item?.price,
      variant: item?.variant?.options && Object.values(item?.variant?.options).join(' '),
    }))
}
